export default __webpack_public_path__ + "static/media/portadaGs360SasWizard.8d630601.png";